export enum Role {
  ROOT = 'ROOT',
  ADMIN = 'ADMIN',
  OBSERVER = 'OBSERVER',
  TRADE_MARKETING_COORDINATOR = 'TRADE_MARKETING_COORDINATOR',
  PROMOTER = 'PROMOTER',
  PROMOTER_MANAGER = 'PROMOTER_MANAGER',
  SUPERVISOR = 'SUPERVISOR',
  SELLER = 'SELLER',
}

type RoleType = keyof typeof Role

export const roleMap: Record<Exclude<RoleType, 'ROOT'>, string> = {
  ADMIN: 'Administrdor',
  TRADE_MARKETING_COORDINATOR: 'Coordenador de Trademarketing',
  OBSERVER: 'Diretoria',
  PROMOTER: 'Promotor',
  PROMOTER_MANAGER: 'Gerente de promotores',
  SUPERVISOR: 'Supervisor',
  SELLER: 'Vendedor',
}
